export function generateTagsQueryParams(selectedTags = [], operator = "OR") {
    // If there are no tags, return empty string
    if (selectedTags.length === 0) return "";

    // If there are tags, generate query parameters containing tag data
    // Sample param: "&tags[terms]=45,64&tags[operator]=AND"
    const tagsTermsQueryParamBase = "tags[terms]=";
    const tagsTermsQueryParams = selectedTags.reduce((acc, tag, i, arr) => {
        const isLastItem = arr.length - 1 === i;
        if (isLastItem) return acc.concat(tag.id);
        return acc.concat(`${tag.id},`);
    }, tagsTermsQueryParamBase);
    return `&${tagsTermsQueryParams}&tags[operator]=${operator}`;
}
